var map = {
	".": "eIko",
	"./": "eIko",
	"./01_trade_info": "m2cs",
	"./01_trade_info.json": "m2cs",
	"./02_last_price": "ntfQ",
	"./02_last_price.json": "ntfQ",
	"./03_mark_price": "D6bT",
	"./03_mark_price.json": "D6bT",
	"./04_depth": "pvqc",
	"./04_depth.json": "pvqc",
	"./05_bookTicker": "exCQ",
	"./05_bookTicker.json": "exCQ",
	"./06_kline": "p1RX",
	"./06_kline.json": "p1RX",
	"./07_24hr_ticker": "5LXd",
	"./07_24hr_ticker.json": "5LXd",
	"./index": "eIko",
	"./index.js": "eIko"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kiRb";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/market ^.*$
// module id = kiRb
// module chunks = 3